import classNames from 'classnames';
import { FC, useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import FeatherIcon from 'feather-icons-react';
interface iUpload {
  label: string;
  onChange: (file: any) => void;
}

interface iFile {
  name: string;
  mime: string;
  url: string;
  file: File;
}

/**
 * Load image from file
 */
const loadLocalImage = (file: any): Promise<string> => {
  return new Promise((res) => {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      res(e.target.result as string);
    };
    reader.readAsDataURL(file);
  });
};

const generateFile = async (file: any): Promise<any> => {
  return {
    name: file.name,
    mime: file.type,
    url: await loadLocalImage(file),
    file,
  };
};

const Upload: FC<iUpload> = ({ label, onChange }) => {
  const [file, setFile] = useState<iFile | null>(null);
  const onDrop = useCallback((acceptedFiles) => {
    onChange(acceptedFiles[0]);
    if (acceptedFiles[0]) generateFile(acceptedFiles[0]).then(setFile);
    // Do something with the files
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, accept: 'image/*' });

  const _handleRemove = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setFile(null);
  };

  return (
    <div {...getRootProps()} className={classNames('file-uploader', isDragActive && 'active')}>
      <input {...getInputProps()} />
      {file ? (
        <div className='file-wrapper'>
          <img src={file.url} alt={file.name} />
          <div className='content'>
            <span className='name'>{file.name}</span>
            <span className='mime'>{file.mime}</span>
          </div>
          <div className='close' onClick={_handleRemove}>
            <FeatherIcon icon='x' />
          </div>
        </div>
      ) : (
        <div className='body'>
          <FeatherIcon icon='paperclip' />
          <span className='label'>{label}</span>
        </div>
      )}
    </div>
  );
};

export default Upload;
